<script>

    export default {

        props: {
            text: {
                required: true,
            },
            placeholder: {
                required: false,
            }
        },

        data() {
            return {
                dataText: this.text,
            }
        },

        render() {
            return this.$scopedSlots.default({
                beginning: this.cutText[0],
                injected: this.cutText[1],
                end: this.cutText[2],
            });
        },

        computed: {
            cutText() {
                if (this.placeholder) {
                    this.dataText = this.dataText.replace(this.placeholder, "%splaceholder%s");
                }

                return [
                    this.dataText.replace(/%s.+/, ''),
                    this.dataText.match(/%s.+%s/, '')[0].replace(/%s/g, ''),
                    this.dataText.replace(/.+%s/g, '')
                ];
            },
        }

    }

</script>
